const offerDeclineReasons = {
	NOT_INTERESTED: "notInterested",
	WRONG_FEE: "wrongFee",
	NOT_AVAILABLE: "notAvailable",
	OTHER: "other",
};

export default offerDeclineReasons;
